module.exports = __webpack_public_path__ + "static/media/DSC_0266.b8ce50db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0266.jpg
// module id = 658
// module chunks = 0